import * as React from 'react'

import { StoreDetailsCard } from '../../StoreDetailsCard'
import { openGoogleDirectionMap } from '../../StoreMap/utils'
import { NearbyStoresData } from '../types'

import { ShowMoreStoresButton, StoreSearchResultsContainer } from './styles'

interface StoreSearchResultsProps {
  stores?: NearbyStoresData
  i18nText?: {
    getDirectionsButton: string
    storeDetailsButton: string
    milesText: string
    storePermClosed: string
    storeTempClosed: string
    storeClosedText: string
    storeOpenText: string
    showMoreText: string
  }
  selectedNearbyStore: number
  setSelectedNearbyStore: React.Dispatch<React.SetStateAction<number>>
  storeDetailsHref: (
    region: string,
    town: string,
    storeUrlTag: string,
  ) => string
  storeDetailsOnClick: () => void
}

export const StoreSearchResults = (props: StoreSearchResultsProps) => {
  const [storesToShow, setStoresToShow] = React.useState<number>(10)

  return (
    <React.Fragment>
      <StoreSearchResultsContainer>
        {props.stores &&
          props.stores.slice(0, storesToShow).map((store, index) => {
            return (
              <StoreDetailsCard
                key={store.id}
                getDirectionsHref={openGoogleDirectionMap(
                  `${store.latitude},${store.longitude}`,
                )}
                storeDetailsHref={props.storeDetailsHref(
                  store?.address?.addressLine5 || '',
                  store?.address?.addressLine4 || '',
                  store?.urlTag,
                )}
                storeDetailsOnClick={props.storeDetailsOnClick}
                i18n={props.i18nText}
                fullWidthCard={true}
                entireCardOnClick={props.setSelectedNearbyStore}
                searchCard={true}
                selected={props.selectedNearbyStore === index + 1}
                searchNo={index + 1}
                store={{
                  id: store.id,
                  displayName: store.displayName,
                  relativeDistance: store.relativeDistance,
                  openingTimes: store.openingTimes,
                  address: `${
                    store.address.addressLine1
                      ? `${store.address.addressLine1},`
                      : ''
                  } ${
                    store.address.addressLine2
                      ? `${store.address.addressLine2},`
                      : ''
                  } ${
                    store.address.addressLine3
                      ? `${store.address.addressLine3},`
                      : ''
                  }${
                    store.address.addressLine4
                      ? `${store.address.addressLine4},`
                      : ''
                  } ${
                    store.address.postalCode ? store.address.postalCode : ''
                  }`,
                  storeFacility: store.storeFacility,
                  status: store.status,
                }}
              />
            )
          })}
        {props.stores && props.stores.length > storesToShow && (
          <ShowMoreStoresButton
            emphasis="medium"
            onClick={() => setStoresToShow(storesToShow + 10)}
          >
            {props.i18nText?.showMoreText}
          </ShowMoreStoresButton>
        )}
      </StoreSearchResultsContainer>
    </React.Fragment>
  )
}
